import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FieldStoreState } from '../shared-store/field-store';
import { State } from './state';

export const getProjectTypesState = createFeatureSelector<State>('projectType');
export const getFieldsState =
  createFeatureSelector<FieldStoreState.State>('field');

export const getTypes = (searchParams) =>
  createSelector(getProjectTypesState, (state: State) => {
    return state.types.filter((x) =>
      x.name.toLowerCase().includes(searchParams.toLowerCase())
    );
  });

export const getSelectedType = createSelector(
  getProjectTypesState,
  (state: State) => state.selectedType
);

export const getTypeById = (typeId) =>
  createSelector(getProjectTypesState, (state: State) => {
    return state.types.find((x) => x._id === typeId);
  });
export const isLoading = createSelector(
  getProjectTypesState,
  (state: State) => state.isLoading
);
export const isSelectedTypeLoading = createSelector(
  getProjectTypesState,
  (state: State) => state.isSelectedTypeLoading
);
